import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../css/ReceiptAdmin.css";
import {
  receiptAdminInfo,
  receiptAdminError,
  receiptAdminUpdatedTime,
  receiptAdminLoading,
  fetchAsyncReceiptAdmin,
} from "./ReceiptAdminSlice";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import { DateConverter } from "../../utils/DateConverter";

const ReceiptAdmin: React.FC = () => {
  //ページネーション
  const [page, setPage] = useState<number>(1);
  //storeにアクセス
  //レンタル中情報
  const receiptAdminData = useSelector(receiptAdminInfo);
  //エラー時メッセージ
  const receiptAdminErrorMsg = useSelector(receiptAdminError);
  //ロード中判定
  const receiptAdminLoadingJudge = useSelector(receiptAdminLoading);
  //データ取得時間
  const receiptAdminGetTime = useSelector(receiptAdminUpdatedTime);
  const dispatch = useDispatch();

  //データ取得
  useEffect(() => {
    dispatch(fetchAsyncReceiptAdmin(page));
  }, [dispatch, page]);

  const history = useHistory();

  //詳細ページに飛ぶ
  const jumpToDetail = (item: any) => {
    history.push("/User_detail", { user_id: item });
  };

  return (
    <div className="position_row">
      <div className="receipt_container">
        <h1 className="receipt_title">領収書発行一覧</h1>
        <div className="time">最終更新時間 : {receiptAdminGetTime}</div>
        <table className="item_container">
          <thead>
            <tr key={"receipt_title"} className="item_container">
              <td className="box font-size">　</td>
              <td className="box font-size">No.</td>
              <td className="item  font-size">レンタルID</td>
              <td className="item  font-size">利用者</td>
              <td className="item  font-size">名義</td>
              <td className="item  font-size">利用日時</td>
              <td className="item  font-size">利用料金</td>
              <td className="item  font-size">発行時間</td>
            </tr>
          </thead>
          <tbody>
            {receiptAdminData !== null &&
              receiptAdminData.map((item) => (
                <tr key={item.receipt_id} className="item_container">
                  <td className="box  font-size">
                    <input type="checkbox" className="checkbox" />
                  </td>
                  <td className="box font-size">{item.receipt_id}</td>
                  <td className="item font-size">{item.rent_id}</td>
                  <td
                    className="item font-size"
                    // onDoubleClick={() => jumpToDetail(item.user_id)}
                  >
                    {item.name}
                  </td>
                  <td className="item font-size">{item.receipt_name}</td>
                  <td className="item font-size">
                    {DateConverter(item.start_date)}
                  </td>
                  <td className="item font-size">{item.actual_fee}</td>
                  <td className="item font-size">
                    {DateConverter(item.issue_time)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="receipt_footer">
          <button
            onClick={() => setPage((prevPage) => prevPage - 1)}
            disabled={page === 1}>
            前へ
          </button>
          <span className="receipt_page">{page}</span>
          <button onClick={() => setPage((prevPage) => prevPage + 1)}>
            次へ
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptAdmin;
